import {WrapperCategories, WrapperDescriptionComingSoon } from './Simulation.styled';
import { useEffect} from 'react';
import { Helmet } from "react-helmet-async";
import { META_DATA } from "../utils/constants";
import { Button } from '@mui/material';
import { Link } from 'react-router-dom';
import { handleScrollUp } from '../utils/helpers';
import { useAuth } from '../context/authContext';
import { SimulationListRegister } from '../components/SimulationListRegister';
import { SimulationListNotRegister } from '../components/SimulationListNotRegister';

const Category = () => {
    const { isAuthenticated } = useAuth();   
    
    const { title, description, keywords } = META_DATA?.simulation;
  
    useEffect(() => {
        handleScrollUp();
        localStorage.clear();
    }, []) 
    

    return (
        <>
            <Helmet>
                <title>{title}</title>
                <meta name="keywords" content={keywords} />
                <meta name="description" content={description} />
            </Helmet>
          
                 
            <WrapperCategories>
                {isAuthenticated? <SimulationListRegister/>: <SimulationListNotRegister />}                            

                <Button component={Link} to="/" variant="outlined">torna alla home</Button>

                <WrapperDescriptionComingSoon>
                    <span>
                       Altri quiz saranno presto disponibili! Rimani aggiornato su tutte le novità seguendoci sui social.
                    </span>
                </WrapperDescriptionComingSoon>
            </WrapperCategories>    
    </>      
)};

export default Category;